// extracted by mini-css-extract-plugin
export default {"wrap":"loginUserInfo_wrap__r+YLj","name":"loginUserInfo_name__MedQn"};